// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-nav[data-v-8ebb95f8] {\n  display: flex;\n  align-items: center;\n  font-size: 14px !important;\n  font-weight: normal !important;\n}\n.survey-nav .back-button[data-v-8ebb95f8] {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
